module.exports = __webpack_public_path__ + "/build/web/images/warranty@2x.171690c150ddbbaf0d19af2222711bc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/warranty@2x.jpg
// module id = 216
// module chunks = 13